import * as csv from './csv';
import * as auth from './auth';
import * as upload from './upload';

export const api = {
  csv,
  auth,
  upload,
};
